import { ThingShadow } from '@cco/model';
import { Dictionary } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as AssetThingMapStore from './asset-thing-map.reducer';
import * as IotThingsStore from './iot-things.reducer';

const selectIotThingsState = createFeatureSelector<IotThingsStore.State>(IotThingsStore.featureKey);

const selectAssetThingMapsState = createSelector(
  selectIotThingsState,
  state => state.assetThingMaps,
);
export const selectThingNamesByAssetUuidAndThingTypeName = createSelector(
  selectAssetThingMapsState,
  (
    entities: Dictionary<AssetThingMapStore.AssetThingMap>,
    props: { assetUuid: string; thingTypeName: string },
  ) => {
    return entities && entities[props.assetUuid]?.byThingType[props.thingTypeName];
  },
);
export const selectThingNameByAssetUuidAndThingTypeName = createSelector(
  selectThingNamesByAssetUuidAndThingTypeName,
  (thingNames: string[] | undefined, props: { assetUuid: string; thingTypeName: string }) => {
    if (thingNames) {
      if (thingNames.length > 1) {
        throw new Error(
          `This selector should not be used when there is the possibility of more than one matching thingName!  assetUuid=${props.assetUuid}, thingTypeName=${props.thingTypeName}, thingNames.length=${thingNames.length}`,
        );
      }
      return thingNames[0];
    }
  },
);

const selectThingsState = createSelector(selectIotThingsState, state => state.things);
const selectThingEntities = createSelector(selectThingsState, state => state.entities);
export const selectThingDocumentsByAssetUuidAndThingTypeName = createSelector(
  selectThingEntities,
  selectThingNamesByAssetUuidAndThingTypeName,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  (entities, thingNames, props: { assetUuid: string; thingTypeName: string }) => {
    return thingNames
      ?.filter(thingName => entities && entities[thingName])
      .map(thingName => entities && entities[thingName]);
  },
);
export const selectThingDocumentByAssetUuidAndThingTypeName = createSelector(
  selectThingDocumentsByAssetUuidAndThingTypeName,
  (thingDocuments, props: { assetUuid: string; thingTypeName: string }) => {
    if (thingDocuments) {
      if (thingDocuments.length > 1) {
        throw new Error(
          `This selector should not be used when there is the possibility of more than one matching thing document!  assetUuid=${props.assetUuid}, thingTypeName=${props.thingTypeName}, thingDocuments.length=${thingDocuments.length}`,
        );
      }

      return thingDocuments[0];
    }
  },
);

const selectThingShadowsState = createSelector(selectIotThingsState, state => state.shadows);
export const selectThingShadowsByAssetUuidAndThingTypeName = createSelector(
  selectThingShadowsState,
  selectThingNamesByAssetUuidAndThingTypeName,
  (
    entities: Dictionary<ThingShadow<Record<string, unknown>>>,
    thingNames,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    props: { assetUuid: string; thingTypeName: string },
  ) => {
    return thingNames
      ?.filter(thingName => entities && entities[thingName])
      .map(thingName => entities && entities[thingName]);
  },
);
const selectThingShadowRequestsState = createSelector(
  selectIotThingsState,
  state => state.shadowRequests,
);
export const selectThingShadowRequestFailedByAssetUuidAndThingTypeName = createSelector(
  selectThingShadowRequestsState,
  selectThingNamesByAssetUuidAndThingTypeName,
  (
    requests,
    thingNames,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    props: { assetUuid: string; thingTypeName: string },
  ) => {
    return !!thingNames?.some(thingName => 'failed' === requests?.[thingName]?.status);
  },
);
export const selectThingShadowByAssetUuidAndThingTypeName = createSelector(
  selectThingShadowsByAssetUuidAndThingTypeName,
  (thingShadaows, props: { assetUuid: string; thingTypeName: string }) => {
    if (thingShadaows) {
      if (thingShadaows.length > 1) {
        throw new Error(
          `This selector should not be used when there is the possibility of more than one matching thing document!  assetUuid=${props.assetUuid}, thingTypeName=${props.thingTypeName}, thingDocuments.length=${thingShadaows.length}`,
        );
      }

      return thingShadaows[0];
    }
  },
);
